export default __webpack_public_path__ + "static/media/hero-covetrus.79e9d00a.webp";